import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Section = styled.section`
    padding: 80px 20px;
    text-align: center;
    background: #f9f9f9;
`;

const Title = styled.h2`
    color: #007bff;
    margin-bottom: 1rem;
`;

const Text = styled.p`
    margin-bottom: 2rem;
`;

const Form = styled.form`
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const Input = styled.input`
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 8px;
`;

const Button = styled.button<{ disabled?: boolean }>`
    background-color: ${({ disabled }) => (disabled ? "#999" : "#007bff")};
    color: white;
    border: none;
    padding: 12px;
    border-radius: 8px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    font-weight: bold;
    transition: background-color 0.3s;
`;

export const Contact: React.FC = () => {
    const { t } = useTranslation();
    const [form, setForm] = useState({ name: "", email: "", message: "" });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const subject = encodeURIComponent(`Message from ${form.name}`);
        const body = encodeURIComponent(
            `Name: ${form.name}\nEmail: ${form.email}\n\nMessage:\n${form.message}`
        );
        window.location.href = `mailto:emiliano.daluz@gmail.com?subject=${subject}&body=${body}`;
    };

    const isDisabled =
        !form.name.trim() || !form.email.trim() || !form.message.trim();

    return (
        <Section id="contact">
            <Title>{t("contact.title")}</Title>
            <Text>{t("contact.text")}</Text>
            <Form onSubmit={handleSubmit}>
                <Input
                    type="text"
                    name="name"
                    placeholder={t("contact.name")}
                    value={form.name}
                    onChange={handleChange}
                />
                <Input
                    type="email"
                    name="email"
                    placeholder={t("contact.email")}
                    value={form.email}
                    onChange={handleChange}
                />
                <Input
                    type="text"
                    name="message"
                    placeholder={t("contact.message")}
                    value={form.message}
                    onChange={handleChange}
                />
                <Button type="submit" disabled={isDisabled}>
                    {t("contact.button")}
                </Button>
            </Form>
        </Section>
    );
};
